const LogoIPacOnline = (
  <svg
    id='ipac-logo'
    xmlns='http://www.w3.org/2000/svg'
    width='307.48'
    height='306.15'
    viewBox='0 0 307.48 306.15'
  >
    <g>
      <path
        className='shadow'
        d='M307.48,213.52c0,47.68-47.76,92.63-92.63,92.63H15.1V13.99s-6.49.02,44.67.02h247.71v199.51Z'
      />
      <path
        className='bg'
        d='M292.65,199.53c0,51.16-41.47,92.63-92.63,92.63H.27V0s-6.49.03,44.67.03h247.71v199.51Z'
      />
      <path d='M46.57,172.18v-69.7h14.59v69.7h-14.59Z' />
      <path d='M65.88,172.18v-69.7h30.76c13.65,0,22.36,9.97,22.36,22.57s-8.71,21.84-22.36,21.84h-16.17v25.3h-14.59ZM94.33,135.02c8.4,0,11.86-4.31,11.86-10.4,0-5.77-3.46-10.08-11.86-10.08h-13.86v20.47h13.86Z' />
      <path d='M157.22,172.18l-4.41-14.38h-25.72l-4.94,14.38h-15.43l24.88-69.7h16.9l24.57,69.7h-15.85ZM139.9,118.11h-.11l-8.93,27.72h17.74l-8.71-27.72Z' />
      <path d='M229.97,148.24c-2.94,15.85-13.86,26.35-30.02,26.35-18.27,0-32.23-12.49-32.23-36.43s12.49-38,32.44-38c17.43,0,28.45,11.13,29.81,25.19h-14.59c-2-7.87-8.19-12.6-15.12-12.6-12.07,0-17.74,9.35-17.74,24.56s5.67,24.57,17.01,24.57c8.61,0,13.86-4.93,15.85-13.65h14.59Z' />
      <path d='M267.81,74.93l-32.48-12.65c-.92-.36-1.83.55-1.47,1.47l12.65,32.48c.35.89,1.57.98,2.04.15l4.47-7.87c.37-.65,1.26-.77,1.79-.24l8.52,8.52c.44.44,1.16.44,1.61,0l3.44-3.44c.44-.44.44-1.16,0-1.61l-8.52-8.52c-.53-.53-.41-1.42.24-1.79l7.87-4.47c.83-.47.74-1.7-.15-2.04Z' />
      <path d='M239.68,57.45c-.2,0-.41-.08-.56-.23-.31-.31-.31-.81,0-1.12l8.96-8.96c.31-.31.81-.31,1.12,0,.31.31.31.81,0,1.12l-8.96,8.96c-.16.16-.36.23-.56.23Z' />
      <path d='M218.9,78.23c-.2,0-.41-.08-.56-.23-.31-.31-.31-.81,0-1.12l8.96-8.96c.31-.31.81-.31,1.12,0,.31.31.31.81,0,1.12l-8.96,8.96c-.16.16-.36.23-.56.23Z' />
      <path d='M228.17,56.73c-.2,0-.41-.08-.56-.23l-8.96-8.96c-.31-.31-.31-.81,0-1.12.31-.31.81-.31,1.12,0l8.96,8.96c.31.31.31.81,0,1.12-.16.16-.36.23-.56.23Z' />
      <path d='M234.19,54.43c-.44,0-.79-.36-.79-.79v-6.34c0-.44.36-.79.79-.79s.79.36.79.79v6.34c0,.44-.36.79-.79.79Z' />
      <path d='M225.86,62.76h-6.34c-.44,0-.79-.36-.79-.79s.36-.79.79-.79h6.34c.44,0,.79.36.79.79s-.36.79-.79.79Z' />
      <text transform='translate(43.89 223.42) scale(1.09 1)'>
        <tspan x='0' y='0'>
          ONLINE
        </tspan>
      </text>
    </g>
  </svg>
);

export default LogoIPacOnline;
